export enum ActionTypeEnum {
  SIGN,
  REQUEST_INFORMATION
}
